<template>
  <div class="user-list">
    <div v-if="isAdmin">
      <b-form-input v-model="user" list="users-list" @change="addUser($event)"></b-form-input>
      <datalist id="users-list">
        <option v-for="user in users" :key="user.uid">{{ user.email }}</option>
      </datalist>
    </div>
    <table class style="padding-top: 5px">
      <tbody>
        <tr v-for="user in participants" :key="user.uid">
          <td class="user-element">{{user.email}}</td>
          <td>
            <button @click="removeUser(user)">
              <icon-base width="10" icon-name="remove">
                <icon-cross />
              </icon-base>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import user from '@/services/user'
import { mapState } from 'vuex'
import IconBase from './components/IconBase.vue'
import IconCross from './components/icons/IconCross.vue'

export default {
  props: {
    participants: {
      type: Array,
      required: true,
    },
  },
  components: {
    IconBase,
    IconCross,
  },
  data() {
    return {
      user: null,
      users: [],
    }
  },
  computed: {
    ...mapState(['userList', 'currentDash']),
    isAdmin() {
      return this.$can('update', 'Dashboard_' + this.currentDash)
    },
  },
  mounted() {
    this.loadUsers()
  },
  methods: {
    loadUsers() {
      this.users = this.userList || []
    },
    addUser(email) {
      const userFinder = user => user.email === email
      const user = this.users.find(userFinder)
      const participant = this.participants.find(userFinder)

      if (user && !participant) {
        this.user = ''
        this.$emit('addParticipant', user)
      }
    },
    removeUser(user) {
      this.$emit('removeParticipant', user)
    },
  },
}
</script>
<style scoped>
.user-list {
  height: 100%;
  overflow: auto;
  padding-left: 5px;
  padding-top: 8px;
}
.img-msg {
  border-radius: 50%;
  width: 50px;
  margin-right: 5px;
}
.user-element {
  font-size: 20px;
  vertical-align: middle;
}
</style>
